import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const FooterContact = ({ heading, privacyLabel, termsLabel }) => (
  <div className="md:col-span-4">
    <p className="text-xs uppercase tracking-[0.25em] text-[#C6A87C] mb-5">{heading}</p>
    <ul className="space-y-3 mb-6">
      <li>
        <Link
          data-testid="footer-privacy"
          to="/privacy"
          className="text-sm text-[#E2E8F0] hover:text-[#C6A87C] transition-colors"
        >
          {privacyLabel}
        </Link>
      </li>
      <li>
        <Link
          data-testid="footer-terms"
          to="/terms"
          className="text-sm text-[#E2E8F0] hover:text-[#C6A87C] transition-colors"
        >
          {termsLabel}
        </Link>
      </li>
    </ul>
    <div className="space-y-3 text-sm text-[#A0AEC0]">
      <a href="tel:+19129334539" className="flex items-center gap-3 hover:text-[#C6A87C] transition-colors">
        <Phone className="w-4 h-4" />
        +1 912-933-4539
      </a>
      <a
        href="mailto:rsv@hrmembers.com"
        className="flex items-center gap-3 hover:text-[#C6A87C] transition-colors break-all"
      >
        <Mail className="w-4 h-4 shrink-0" />
        rsv@hrmembers.com
      </a>
      <div className="flex items-start gap-3">
        <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
        <div>
          <p>30 Gould N Ste, Sheridan, WY 82801</p>
          <p>SM 6A, Cancún, QR 77500</p>
        </div>
      </div>
    </div>
  </div>
);

export default FooterContact;
